/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2025, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <React.Fragment>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m12 .247-9.249.8407C1.3346 1.2165.25 2.4041.25 3.8264V4.5c0 .9665.7835 1.75 1.75 1.75h20c.9665 0 1.75-.7835 1.75-1.75v-.6736c0-1.4223-1.0846-2.6099-2.501-2.7387L12 .247ZM2.8868 2.5815 12 1.753l9.1132.8285A1.25 1.25 0 0 1 22.25 3.8264V4.5a.25.25 0 0 1-.25.25H2a.25.25 0 0 1-.25-.25v-.6736a1.25 1.25 0 0 1 1.1368-1.2448Z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M1.75 20.75A.25.25 0 0 1 2 20.5h8a.75.75 0 0 0 0-1.5H2c-.9665 0-1.75.7835-1.75 1.75V22c0 .9665.7835 1.75 1.75 1.75h15.5a.75.75 0 0 0 0-1.5H2a.25.25 0 0 1-.25-.25v-1.25Z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6.5 9c0-.9665-.7835-1.75-1.75-1.75H4c-.9665 0-1.75.7835-1.75 1.75v7c0 .9665.7835 1.75 1.75 1.75h.75c.9665 0 1.75-.7835 1.75-1.75V9Zm-1.75-.25A.25.25 0 0 1 5 9v7a.25.25 0 0 1-.25.25H4a.25.25 0 0 1-.25-.25V9A.25.25 0 0 1 4 8.75h.75Z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M20 7.25c.9665 0 1.75.7835 1.75 1.75v2.5a.75.75 0 0 1-1.5 0V9a.25.25 0 0 0-.25-.25h-1a.25.25 0 0 0-.25.25v1a.75.75 0 0 1-1.5 0V9c0-.9665.7835-1.75 1.75-1.75h1Z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M11.5 9c0-.9665-.7835-1.75-1.75-1.75H9c-.9665 0-1.75.7835-1.75 1.75v7c0 .9665.7835 1.75 1.75 1.75h.75c.9665 0 1.75-.7835 1.75-1.75V9Zm-1.75-.25A.25.25 0 0 1 10 9v7a.25.25 0 0 1-.25.25H9a.25.25 0 0 1-.25-.25V9A.25.25 0 0 1 9 8.75h.75Z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M14.812 7.25c.9665 0 1.75.7835 1.75 1.75v2a.75.75 0 0 1-1.5 0V9a.25.25 0 0 0-.25-.25H14a.25.25 0 0 0-.25.25v5.5a.75.75 0 0 1-1.5 0V9c0-.9665.7835-1.75 1.75-1.75h.812Z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M16.773 12.8839c.1456-1.0197 1.3929-1.4355 2.1213-.7071l1.4142 1.4142c.7284.7284.3126 1.9757-.7071 2.1213l-.33.0472a.2493.2493 0 0 0-.1414.0707l-.7318.7318 4.6619 4.1135c.7307.6448.7659 1.7724.0769 2.4614-.6891.6891-1.8167.6539-2.4615-.0768l-4.1135-4.662-.7318.7319a.2496.2496 0 0 0-.0707.1414l-.0472.33c-.1457 1.0197-1.393 1.4355-2.1213.7071l-1.4142-1.4142c-.7284-.7284-.3126-1.9756.7071-2.1213l.33-.0472a.2496.2496 0 0 0 .1414-.0707l3.2998-3.2998a.2493.2493 0 0 0 .0707-.1414l.0472-.33Zm1.4076.7005a1.75 1.75 0 0 1-.4648.8316l-3.2999 3.2998a1.7492 1.7492 0 0 1-.8315.4648l.7203.7203a1.7492 1.7492 0 0 1 .4648-.8315l3.2998-3.2999a1.75 1.75 0 0 1 .8316-.4648l-.7203-.7203Zm3.6197 8.4833-2.0055-2.273 2.2729 2.0056a.1894.1894 0 1 1-.2674.2674Z"
      clipRule="evenodd"
    />
  </React.Fragment>,
  'MenuGovernance'
);
